import React from "react";
//Limitless imports
import { formatDate as formatDateUtil, formatSimpleDate } from "@limitless/common/utils";
import { formatCurrency as formatCurrencyUtil, formatExpertName, doesUserHavePolicy, useGraphAPIHook } from "../../../portal";
import { useAppConfig, useNotificationContext } from "@limitless/common/hooks";
import { useResources } from "@limitless/common/hooks/platform-resource/PlatformResourceContext";
import { loadProfile, loadProfileImage, saveProfileChanges } from "../../apis/expert-profile-api/ExpertProfileAPI";
import { verifyPayPalMutation } from "../../apis/expert-profile-api/ExpertProfileQueries";
import { fetchPlatformResources, BRAND_ASSETS } from "@limitless/common/apis/resource-api";
import { UPDATE_MFA_PHONENUMBER, UPDATE_MFA_PHONENUMBER_WITH_CODE, updateMfaPhoneNumber } from "../../apis/expert-mfa-api/ExpertMfaQueries";
export const PROFILE_INITIAL_STATE = {
  balance: 0,
  custRating: 0,
  points: 0,
  country: "GB",
  language: "en",
  balanceCurrency: "GBP",
  cognitoPolicies: [],
  groups: [],
  userName: "",
  loading: true,
  mgsPendingFeeAllocation: 0,
  hasSeenWebGuide: true,
  helpGuideAvailable: false,
  isIdentityVerified: false,
  isOnboaridngInviteChecked: false
};
const UPDATE_PROFILE = "update-profile";
const RESET_PROFILE = "reset-profile";
const SET_LOAD_PROFILE = "load-profile";
const profileReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_PROFILE:
      {
        var _newProfile$identityV;
        const newProfile = {
          ...state,
          ...action.payload
        };
        if ((_newProfile$identityV = newProfile.identityVerification) !== null && _newProfile$identityV !== void 0 && _newProfile$identityV.status) {
          var _newProfile$identityV2;
          newProfile.isIdentityVerified = ((_newProfile$identityV2 = newProfile.identityVerification) === null || _newProfile$identityV2 === void 0 ? void 0 : _newProfile$identityV2.status) === "match" ? true : false;
        }
        return newProfile;
      }
    case SET_LOAD_PROFILE:
      return {
        ...state,
        loading: true
      };
    case RESET_PROFILE:
      return PROFILE_INITIAL_STATE;
    default:
      throw new Error(`Unsupported profile action type ${action.tyoe}`);
  }
};

/** convenience wrapper around the expert profile currently managed in Redux */
export const useExpertProfile = () => {
  const [profile, dispatch] = React.useReducer(profileReducer, PROFILE_INITIAL_STATE);
  const [profileLoading, setProfileLoading] = React.useState(false);
  const [securityProfileChanged, setSecurityProfileChanged] = React.useState(false);
  const [isEditable, setIsEditable] = React.useState(false);
  const [countInactivityMember, setCountInactivityMember] = React.useState(0);
  const [hasProfileLoadFailed, setHasProfileLoadFailed] = React.useState(false);
  const [isDarkMode, setIsDarkMode] = React.useState(false);
  const [profileTenantsBrandAsset, setProfileTenantsBrandAsset] = React.useState([]);
  const {
    addSuccessNotification,
    addFailureNotification,
    addFailureNotificationWithNoDuration
  } = useNotificationContext();
  const {
    config
  } = useAppConfig();
  const {
    setApplicationLanguage
  } = useResources();
  const {
    mutateData
  } = useGraphAPIHook();
  const {
    localeConfig: {
      countryList
    }
  } = config;
  const fetchProfile = () => {
    loadExpertProfile();
    loadExpertProfilePicture();
  };
  React.useEffect(() => {
    if (process.env.REACT_APP_NAME === "ExpertWebApp" && profile.receiveBrowserTaskNotifications) {
      if ("Notification" in window && Notification.permission !== "granted") {
        // We need to ask the user for permission
        Notification.requestPermission();
      }
    }
  }, [profile.receiveBrowserTaskNotifications]);
  React.useEffect(() => {
    const {
      identityVerification
    } = profile;
    setIsEditable((identityVerification === null || identityVerification === void 0 ? void 0 : identityVerification.status) === "match");
  }, [profile === null || profile === void 0 ? void 0 : profile.identityVerification]);
  React.useEffect(() => {
    loadInactivatedMemberships();
  }, [countInactivityMember]);
  React.useEffect(() => {
    if (process.env.REACT_APP_NAME.includes("Expert") && profile.groups.length > 0) {
      let data = [];
      const profileTenants = [...new Set(profile.groups.map(v => v.tenantName))];
      profileTenants.forEach(item => {
        fetchPlatformResources({
          locale: "en-GB",
          // Require to put this as dynamic value
          resourceList: [BRAND_ASSETS],
          tenantName: item,
          ignoreCache: true
        }, results => {
          if (results.length > 0 && results[0].content && Object.keys(results[0].content).length > 0) {
            var _results$, _results$$content, _results$2, _results$2$content, _results$2$content$br, _results$2$content$br2;
            data = [...data, {
              tenantName: item,
              brandAssetUrl: ((_results$ = results[0]) === null || _results$ === void 0 ? void 0 : (_results$$content = _results$.content) === null || _results$$content === void 0 ? void 0 : _results$$content.brandAssets[0].urls[0]) || null,
              onboardingTenatBrandAssetUrl: ((_results$2 = results[0]) === null || _results$2 === void 0 ? void 0 : (_results$2$content = _results$2.content) === null || _results$2$content === void 0 ? void 0 : (_results$2$content$br = _results$2$content.brandAssets) === null || _results$2$content$br === void 0 ? void 0 : (_results$2$content$br2 = _results$2$content$br.find(item => (item === null || item === void 0 ? void 0 : item.applicationName) === "onboardingAssets")) === null || _results$2$content$br2 === void 0 ? void 0 : _results$2$content$br2.urls[0]) || null
            }];
            setProfileTenantsBrandAsset(data);
          } else if (results.length > 0 && !results[0].content) {
            fetchPlatformResources({
              locale: "en-US",
              resourceList: [BRAND_ASSETS],
              tenantName: item,
              ignoreCache: true
            }, resultsData => {
              var _resultsData$, _resultsData$$content;
              data = [...data, {
                tenantName: item,
                brandAssetUrl: ((_resultsData$ = resultsData[0]) === null || _resultsData$ === void 0 ? void 0 : (_resultsData$$content = _resultsData$.content) === null || _resultsData$$content === void 0 ? void 0 : _resultsData$$content.brandAssets[0].urls[0]) || null
              }];
              setProfileTenantsBrandAsset(data);
            });
          } else {
            setProfileTenantsBrandAsset([]);
          }
        });
      });
    }
  }, [profile.groups]);
  const loadExpertProfile = () => {
    setProfileLoading(true);
    setHasProfileLoadFailed(false);
    loadProfile().then(expertProfile => {
      var _expertProfile$inacti;
      setApplicationLanguage(expertProfile.userLocale);
      dispatch({
        type: UPDATE_PROFILE,
        payload: {
          ...expertProfile,
          loading: false
        }
      });
      setCountInactivityMember(expertProfile === null || expertProfile === void 0 ? void 0 : (_expertProfile$inacti = expertProfile.inactivatedMemberships) === null || _expertProfile$inacti === void 0 ? void 0 : _expertProfile$inacti.length);
      setProfileLoading(false);
    }).catch(() => {
      setProfileLoading(false);
      setHasProfileLoadFailed(true);
    });
  };
  const loadInactivatedMemberships = () => {
    const stickyNotification = countInactivityMember === 1 ? "You are no longer able to receive tasks for {0} due to inactivity. Please reach out to the support team from Contact Support in the Help menu for further information." : "You are no longer able to receive tasks for several brands due to inactivity. Please reach out to the support team from Contact Support in the Help menu for further information.";
    // eslint-disable-next-line no-unused-expressions
    countInactivityMember >= 1 && (profile === null || profile === void 0 ? void 0 : profile.inactivatedMemberships.length) !== 0 && addFailureNotificationWithNoDuration(stickyNotification, countInactivityMember === 1 ? profile.inactivatedMemberships[0] : "");
  };
  const loadExpertProfilePicture = () => {
    loadProfileImage().then(expertProfilePicture => {
      dispatch({
        type: UPDATE_PROFILE,
        payload: {
          picture: expertProfilePicture
        }
      });
    }).catch(() => dispatch({
      type: UPDATE_PROFILE,
      payload: {
        picture: ""
      }
    }));
  };
  const updateProfile = profileProps => {
    dispatch({
      type: UPDATE_PROFILE,
      payload: profileProps
    });
  };
  const formatDate = (utcDate, locale, returnSimple) => {
    return returnSimple ? formatSimpleDate(utcDate) : formatDateUtil(utcDate, profile, countryList, locale);
  };
  const formatCurrency = amount => {
    return formatCurrencyUtil(amount, profile);
  };
  const getFormattedBalance = (balance = profile.balance) => {
    return formatCurrency(balance);
  };
  const getExpertName = () => {
    const {
      firstName,
      lastName,
      email
    } = profile;
    return formatExpertName(firstName, lastName, email, 15);
  };
  const getExpertRole = () => {
    const {
      userRole
    } = profile;
    return userRole === "expert" ? "" : userRole;
  };
  const saveCognitoData = ({
    policies,
    _phoneDetails
  }) => {
    dispatch({
      type: UPDATE_PROFILE,
      payload: {
        cognitoPolicies: policies,
        _phoneDetails
      }
    });
  };
  const canUserAccess = policy => {
    return doesUserHavePolicy(policy, profile);
  };
  const setHelpGuideAvailable = value => {
    dispatch({
      type: UPDATE_PROFILE,
      payload: {
        helpGuideAvailable: value
      }
    });
  };
  const verifyPayPalAccount = (verificationData, callback = () => null) => {
    const options = {
      dataKey: "verifyPaypalAccount",
      mutation: verifyPayPalMutation(verificationData),
      variables: {
        ...verificationData
      },
      functionName: "ExpertProfileHook verifyPayPalAccount"
    };
    mutateData(options).then(profileData => {
      updateProfile({
        ...profile,
        verificationRequired: profileData.verificationRequired,
        paypalVerificationCodeExpiry: profileData.paypalVerificationCodeExpiry
      });
      callback();
    }).catch(error => {
      callback({
        hasError: true,
        error: error !== null && error !== void 0 ? error : null
      });
    });
  };
  const senEmailOtp = (phoneNumberChangeVerificationCode, callback) => {
    let options = {
      dataKey: "updateMfaPhoneNumber",
      mutation: UPDATE_MFA_PHONENUMBER,
      functionName: "ExpertProfileHook updateMfaPhoneNumber"
    };
    if (phoneNumberChangeVerificationCode) {
      options = {
        ...options,
        mutation: UPDATE_MFA_PHONENUMBER_WITH_CODE,
        variables: {
          phoneNumberChangeVerificationCode
        }
      };
    }
    mutateData(options).then(User => {
      callback(User);
    }).catch(error => {
      callback({
        hasError: true,
        error: error !== null && error !== void 0 ? error : null
      });
    });
  };
  const saveProfile = (profileData, callback = () => null, notificationHeader = "", showNotification = true) => {
    setProfileLoading(true);
    saveProfileChanges(profileData).then(newProfile => {
      var _newProfile$verificat;
      if (!Object.keys(profileData).includes("paypalAccount") || !((_newProfile$verificat = newProfile.verificationRequired) !== null && _newProfile$verificat !== void 0 && _newProfile$verificat.fields.includes("paypalAccount"))) {
        if (showNotification) {
          addSuccessNotification("Profile changes successfully saved", notificationHeader);
        }
      }
      updateProfile({
        ...profileData,
        ...newProfile
      });
      setProfileLoading(false);
      callback(newProfile);
    }).catch(error => {
      if (error.code === "1402") {
        // {code: "1402", message: "Duplicate paypal account"}
        addFailureNotification("PayPal email address is not valid, since it is in use by another user");
      } else {
        addFailureNotification("Failed to save profile changes, please try again", notificationHeader);
      }
      setProfileLoading(false);
      callback({
        hasError: true,
        error: error.message
      });
    });
  };
  const clearProfile = () => {
    dispatch({
      type: RESET_PROFILE
    });
    setSecurityProfileChanged(false);
    setIsDarkMode(false);
  };
  const updateOnboaridngInviteCheck = isOnboaridngInviteChecked => {
    updateProfile({
      ...profile,
      isOnboaridngInviteChecked
    });
  };
  const toggleMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  return {
    profile,
    formatDate,
    formatCurrency,
    updateProfile,
    getFormattedBalance,
    getExpertName,
    getExpertRole,
    canUserAccess,
    saveProfile,
    senEmailOtp,
    verifyPayPalAccount,
    loading: profileLoading,
    fetchProfile,
    loadInactivatedMemberships,
    clearProfile,
    saveCognitoData,
    securityProfileChanged,
    setSecurityProfileChanged,
    hasProfileLoadFailed,
    setHelpGuideAvailable,
    loadExpertProfile,
    updateOnboaridngInviteCheck,
    isDarkMode,
    toggleMode,
    isEditable,
    profileTenantsBrandAsset
  };
};